var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        "close-on-click-modal": false,
        width: "690px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.closeDialog,
      },
    },
    [
      _c("div", { attrs: { slot: "title" }, slot: "title" }, [
        _vm._v(_vm._s(_vm.$t("system::rbac::valueAuth_title"))),
      ]),
      _c(
        "div",
        { staticStyle: { display: "flex", "justify-content": "center" } },
        [
          _c("el-transfer", {
            ref: "transfer",
            attrs: {
              filterable: "",
              "filter-method": _vm.filterMethod,
              "filter-placeholder": _vm.$t("system::rbac::请输入内容"),
              data: _vm.data,
              titles: [
                _vm.$t("system::rbac::字段值列表"),
                _vm.$t("system::rbac::已选字段值"),
              ],
            },
            model: {
              value: _vm.list,
              callback: function ($$v) {
                _vm.list = $$v
              },
              expression: "list",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("system::rbac::user_cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.submitForm },
            },
            [_vm._v(" " + _vm._s(_vm.$t("system::rbac::user_confirm")) + " ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }